export default __webpack_public_path__ + "static/media/comida_4.d240a8f5.svg";